import Vue from 'vue'
import { library, config } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

import {
  faUser,
  faLink,
  faUnlink,
  faLock,
  faSignOutAlt,
  faCog,
  faSearch,
  faShoppingCart,
  faCheck,
  faChevronUp,
  faChevronDown,
  faChevronRight,
  faChevronLeft,
  faArrowLeft,
  faArrowRight,
  faPencilAlt,
  faEdit,
  faTrashAlt,
  faPlus,
  faMinus,
  faArrowsAlt,
  faInfoCircle,
  faBuilding,
  faUserFriends,
  faAddressBook,
  faCreditCard,
  faHistory,
  faRetweet,
  faEye,
  faAngleDoubleRight,
  faCopy,
  faStar as faStarSolid,
  faTimes,
  faEyeSlash,
  faAngleDoubleLeft,
  faExternalLinkAlt,
  faSyncAlt,
  faArrowUp,
  faArrowDown,
  faLongArrowAltUp,
  faLongArrowAltDown,
  faUpload,
  faExclamationTriangle,
  faTag,
  faLayerGroup,
  faBox,
  faSpinner
} from '@fortawesome/free-solid-svg-icons'

import { faGithub } from '@fortawesome/free-brands-svg-icons'
import { faStar as faStarRegular, faClone as faCloneRegular } from '@fortawesome/free-regular-svg-icons'

config.autoAddCss = false

library.add(
  faUser,
  faLink,
  faUnlink,
  faLock,
  faSignOutAlt,
  faArrowsAlt,
  faCog,
  faGithub,
  faSearch,
  faShoppingCart,
  faCheck,
  faChevronUp,
  faChevronDown,
  faChevronRight,
  faChevronLeft,
  faArrowLeft,
  faArrowRight,
  faPencilAlt,
  faTrashAlt,
  faPlus,
  faEdit,
  faInfoCircle,
  faBuilding,
  faUserFriends,
  faAddressBook,
  faCreditCard,
  faHistory,
  faStarSolid,
  faStarRegular,
  faCloneRegular,
  faRetweet,
  faEye,
  faMinus,
  faAngleDoubleLeft,
  faAngleDoubleRight,
  faCopy,
  faTimes,
  faEyeSlash,
  faExternalLinkAlt,
  faSyncAlt,
  faArrowUp,
  faArrowDown,
  faLongArrowAltUp,
  faLongArrowAltDown,
  faUpload,
  faExclamationTriangle,
  faTag,
  faLayerGroup,
  faBox,
  faSpinner
)

Vue.component('Fa', FontAwesomeIcon)
